import { appColors } from "./theme";
import { radius } from "./designTokens";

/**
 * Liste sayfası Paper kabuğu.
 * Taşmayı DataTable kendi overflowX:auto ile yönetir; Paper kesmesin.
 */
export const dataListPaperSx = {
  px: { xs: 1.5, md: 2 },
  py: { xs: 1.5, md: 2 },
  borderRadius: `${radius.lg}px`,
  backgroundColor: appColors.white,
  display: "block",
  width: "100%",
  maxWidth: "100%",
  minWidth: 0,
  boxSizing: "border-box",
  // Scroll DataTable içinde; Paper kesmesin
  overflow: "visible",
};

export const dataGridSurfaceSx = {
  border: "none",
  "& .MuiDataGrid-columnSeparator": {
    display: "none",
  },
  "& .MuiDataGrid-cell": {
    borderBottom: `1px solid ${appColors.gray200}`,
    borderRight: "none",
  },
  "& .MuiDataGrid-columnHeaders": {
    borderBottom: `1px solid ${appColors.gray200}`,
    backgroundColor: appColors.gray50,
    color: appColors.gray900,
    fontWeight: 600,
  },
  "& .MuiDataGrid-columnHeader": {
    borderRight: "none",
  },
  "& .MuiDataGrid-footerContainer": {
    borderTop: `1px solid ${appColors.gray200}`,
    borderBottom: "none",
  },
};

export const dataGridTableSx = {
  border: "none",
  "& .MuiDataGrid-cell": {
    display: "flex",
    alignItems: "center",
  },
};

/** Yatay scroll kabı — mobil dahil tüm ekranlarda */
export const dataGridScrollContainerSx = {
  width: "100%",
  maxWidth: "100%",
  minWidth: 0,
  overflowX: "auto",
  overflowY: "visible",
  WebkitOverflowScrolling: "touch",
  touchAction: "pan-x pan-y",
  scrollbarWidth: "thin",
  "&::-webkit-scrollbar": {
    height: 8,
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: appColors.gray300,
    borderRadius: 4,
  },
};
